import API from "./api";
import ENDPOINTS from "./endpoints";

export default API;
export { ENDPOINTS };
